import styled from 'styled-components';

const OurValuesStyle = styled.div`
	.descriptionWrap {
		.description {
			margin-bottom: var(--titleToText);
		}
	}

	.articleWrap {
		counter-reset: my-sec-counter;
		border-top: 2px solid var(--color2);

		.article-item {
			.tableWrap {
				padding-top: calc(var(--titleToText) / 2) !important;
				padding-bottom: calc(var(--titleToText) / 2) !important;
			}

			&:first-child {
				.tableWrap {
					padding-top: var(--titleToText) !important;
				}
			}

			&:last-child {
				.tableWrap {
					padding-bottom: 0 !important;
				}
			}
		}
	}

	.titleStyle {
		display: flex;
		align-items: flex-start;

		.animWrap {
			position: absolute;
			right: 0;
			margin-top: 0;
			padding-top: 0;
		}
	}

	.whatWeDoWrap {
		.whatWeDoItem {
			display: flex;
			align-items: center;
			border-bottom: 2px solid var(--color2);
			padding: var(--sp4x) 0;

			.iconCont {
				width: var(--sp6x);
				height: var(--sp6x);
				margin-right: var(--sp2x);
			}

			.description {
				flex: 1 1 auto;
			}

			&:first-child {
				border-top: 2px solid var(--color2);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.descriptionWrap {
			display: flex;
			justify-content: flex-end;
			flex-wrap: wrap;

			.description {
				flex: 0 0 64%;
			}
		}

		.whatWeDoWrap {
			.whatWeDoItem {
				padding: var(--sp5x) 0;

				.iconCont {
					width: var(--sp7x);
					height: var(--sp7x);
					margin-right: var(--sp11x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 86.5%;
				padding: var(--sp4x) 0;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.descriptionWrap {
			.description {
				flex: 0 0 51%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 90%;
				padding: var(--sp4x) 0;

				.iconCont {
					width: var(--sp8x);
					height: var(--sp8x);
					margin-right: var(--sp6x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 87%;
				padding: var(--sp4x) 0;

				.iconCont {
					width: var(--sp8x);
					height: var(--sp8x);
					margin-right: var(--sp6x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 90%;
				padding: var(--sp5x) 0;

				.iconCont {
					width: var(--sp9x);
					height: var(--sp9x);
					margin-right: var(--sp8x);
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		.descriptionWrap {
			.description {
				flex: 0 0 49%;
			}
		}

		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 90%;
				padding: var(--sp5x) 0;

				.iconCont {
					width: var(--sp10x);
					height: var(--sp10x);
					margin-right: var(--sp10x);
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 87%;
				padding: var(--sp6x) 0;

				.iconCont {
					width: var(--sp11x);
					height: var(--sp11x);
					margin-right: var(--sp13x);
				}
			}
		}
	}
`;

export default OurValuesStyle;
